import { z } from 'zod';
import superjson from 'superjson';

export const schema = z.object({
  page: z.coerce.number().optional(),
  per_page: z.coerce.number().optional(),
});

export type InputType = z.infer<typeof schema>;

export type GithubRepo = {
  id: number;
  name: string;
  full_name: string;
  private: boolean;
  description: string | null;
  default_branch: string;
  updated_at: string;
  owner?: {
    login: string;
    avatar_url: string;
  };
};

export type OutputType = {
  repos: GithubRepo[];
};

export const getGithubRepos = async (input: InputType, init?: RequestInit): Promise<OutputType> => {
  const params = new URLSearchParams();
  if (input.page) params.set('page', input.page.toString());
  if (input.per_page) params.set('per_page', input.per_page.toString());

  const result = await fetch(`/_api/github/repos?${params.toString()}`, {
    method: 'GET',
    credentials: 'include',
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(init?.headers ?? {}),
    },
  });

  if (!result.ok) {
    const errorObject = superjson.parse<{ error: string }>(await result.text());
    throw new Error(errorObject.error);
  }
  return superjson.parse<OutputType>(await result.text());
};
